/**
 * @generated SignedSource<<aa6a269424bc1b4fc1bcb7ed6da5dcee>>
 * @relayHash 10a6e74201e75f7fd05257845e870e22
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 5f78c38bf43db12554ba0f37ad39b4afd115d6ef16213fadbd51e8708bc161d2

import type { ConcreteRequest } from 'relay-runtime';
export type useSpaceEnabledContentTypesQuery$variables = {
  spaceKey?: string | null;
};
export type useSpaceEnabledContentTypesQuery$data = {
  readonly space: {
    readonly id: string | null;
    readonly key: string | null;
    readonly spaceTypeSettings: {
      readonly enabledContentTypes: {
        readonly isBlogsEnabled: boolean;
        readonly isDatabasesEnabled: boolean;
        readonly isEmbedsEnabled: boolean;
        readonly isFoldersEnabled: boolean;
        readonly isLivePagesEnabled: boolean;
        readonly isSlidesEnabled: boolean;
        readonly isWhiteboardsEnabled: boolean;
      };
    };
  } | null;
};
export type useSpaceEnabledContentTypesQuery = {
  response: useSpaceEnabledContentTypesQuery$data;
  variables: useSpaceEnabledContentTypesQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "spaceKey"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "key",
        "variableName": "spaceKey"
      }
    ],
    "concreteType": "Space",
    "kind": "LinkedField",
    "name": "space",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "id"
      },
      {
        "kind": "ScalarField",
        "name": "key"
      },
      {
        "concreteType": "SpaceTypeSettings",
        "kind": "LinkedField",
        "name": "spaceTypeSettings",
        "plural": false,
        "selections": [
          {
            "concreteType": "EnabledContentTypes",
            "kind": "LinkedField",
            "name": "enabledContentTypes",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "isBlogsEnabled"
              },
              {
                "kind": "ScalarField",
                "name": "isDatabasesEnabled"
              },
              {
                "kind": "ScalarField",
                "name": "isEmbedsEnabled"
              },
              {
                "kind": "ScalarField",
                "name": "isLivePagesEnabled"
              },
              {
                "kind": "ScalarField",
                "name": "isSlidesEnabled"
              },
              {
                "kind": "ScalarField",
                "name": "isWhiteboardsEnabled"
              },
              {
                "kind": "ScalarField",
                "name": "isFoldersEnabled"
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useSpaceEnabledContentTypesQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useSpaceEnabledContentTypesQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "10a6e74201e75f7fd05257845e870e22",
    "id": "5f78c38bf43db12554ba0f37ad39b4afd115d6ef16213fadbd51e8708bc161d2",
    "metadata": {},
    "name": "useSpaceEnabledContentTypesQuery",
    "operationKind": "query",
    "text": "query useSpaceEnabledContentTypesQuery($spaceKey:String){space(key:$spaceKey){id,key,spaceTypeSettings{enabledContentTypes{isBlogsEnabled,isDatabasesEnabled,isEmbedsEnabled,isLivePagesEnabled,isSlidesEnabled,isWhiteboardsEnabled,isFoldersEnabled}}}}"
  }
};
})();

(node as any).hash = "b239b4c898f62763088962d6011df617";

export default node;
